import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { focusOutline } from '../utils/focusOutline';
import { Text } from '../Text';
import { theme } from '../theme';
import { useUniqueId } from '../utils/id';
export const CheckBox = forwardRef(function CheckBox({ id: idProp, checked, children, toggle, error, errorMsg }, ref) {
    const id = useUniqueId(idProp);
    return (React.createElement(React.Fragment, null,
        React.createElement(BoxContainer, { id: id },
            React.createElement(Text, { tag: "span", typo: "body-regular", color: error ? 'strawberry' : 'liquorice' }, children),
            React.createElement("input", { ref: ref, type: "checkbox", checked: checked, onChange: toggle }),
            React.createElement(Checkmark, { "$error": error })),
        error && errorMsg && React.createElement(ErrorBox, null, errorMsg)));
});
const Checkmark = styled.span `
  position: absolute;
  left: 0;
  width: 24px;
  height: 24px;
  border: ${({ $error }) => $error
    ? `solid 2px ${theme.colors.strawberry}`
    : `solid 2px ${theme.colors.liquorice}`};
  box-sizing: border-box;
  border-radius: 1px;

  &:before {
    content: '';
    position: absolute;
    display: none;
    top: 9px;
    left: 5px;
    width: 3px;
    height: 8px;
    border-radius: 4px;
    background-color: ${theme.colors.cream};
    -webkit-transform: rotate(316deg);
    -ms-transform: rotate(316deg);
    transform: rotate(316deg);
  }

  &:after {
    content: '';
    position: absolute;
    display: none;
    top: 3px;
    left: 11px;
    width: 3px;
    height: 15px;
    border-radius: 4px;
    background-color: ${theme.colors.cream};
    -webkit-transform: rotate(43deg);
    -ms-transform: rotate(43deg);
    transform: rotate(43deg);
  }
`;
const BoxContainer = styled.label `
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-left: 32px;
  user-select: none;
  cursor: pointer;
  min-height: 24px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    background-color: ${theme.colors.cream};

    &:checked ~ ${Checkmark} {
      background-color: ${theme.colors.liquorice};
      border: solid 2px ${theme.colors.liquorice};
    }

    &:checked ~ ${Checkmark}:before {
      display: block;
    }

    &:checked ~ ${Checkmark}:after {
      display: block;
    }

    ${focusOutline({ selector: `&:focus-visible ~ ${Checkmark}` })}
  }

  &:hover {
    ${Checkmark} {
      background-color: ${theme.colors.coconut};
      border: solid 2px ${theme.colors.liquorice};
    }
  }

  @media (min-width: 768px) {
    padding-left: 32px;
  }

  span {
    border-radius: 6px;
    line-height: 24px;
  }
`;
const ErrorBox = styled.div `
  margin-top: 4px;
  font-size: 12px;
  color: ${theme.colors.strawberry};
`;
//# sourceMappingURL=CheckBox.js.map